import { render, staticRenderFns } from "./LightBeam.vue?vue&type=template&id=614d2f2d&lang=html"
import script from "./LightBeam.vue?vue&type=script&lang=js"
export * from "./LightBeam.vue?vue&type=script&lang=js"
import style0 from "./LightBeam.vue?vue&type=style&index=0&id=614d2f2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports